/*
  GILLSEE CUP 長崎大会「EGING HAPPY MEETING」ページ（sections/c__gillsee-cup-nagasaki-2026.liquid 用）
  栗林さん提供の eging.js をShopifyに移したもの。

  Shopify向けに変えた点
  ・参加フォームを GAS（GILLSEE CUP エントリーフォーム受付）に送信するようにした
    送信先URLはセクション設定から data-endpoint で渡す。text/plain で送る（GASは application/json だとブラウザ側で弾かれるため）
  ・送信に成功したらサンクスページ（セクション設定「送信後に移動するページ」）へ移動する。設定が空なら入力欄を隠し、完了メッセージを表示する
  ・ページを開いたときにGASへ受付状況（?action=status）を問い合わせ、定員に達していれば入力欄とボタンを押せない状態にする
    送信したときに定員に達していた場合（GASが closed を返した場合）も同じ状態にする
*/
(() => {
  function init() {
    document.querySelectorAll('.ec-page').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {threshold: 0, rootMargin: '0px 0px -30px 0px'});
        root.classList.add('ec-motion-enabled');
        root.querySelectorAll('.ec-section > .ec-wrap, .ec-session-grid, .ec-afterparty > .ec-wrap, .ec-wide-photo').forEach(el => {
          el.classList.add('ec-reveal'); observer.observe(el);
        });
      }
      root.querySelectorAll('a[href^="#ec-"]').forEach(link => {
        link.addEventListener('click', event => {
          const target = root.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({behavior: reduce ? 'auto' : 'smooth'});
        });
      });

      const form = root.querySelector('form.ec-form');
      const closeForm = (message, focus) => {
        form.classList.add('is-closed');
        form.querySelectorAll('input, select, button').forEach(el => { el.disabled = true; });
        const button = form.querySelector('button[type="submit"]');
        button.textContent = '受付終了';
        const result = form.querySelector('.ec-form-result');
        result.textContent = message || form.dataset.closedMessage || '参加申込の受付は終了しました。';
        result.hidden = false;
        if (focus) result.focus();
      };

      if (form?.dataset.endpoint) {
        const tournament = form.querySelector('input[name="tournament"]')?.value || '';
        const url = form.dataset.endpoint + '?action=status&tournament=' + encodeURIComponent(tournament);
        fetch(url)
          .then(response => response.json())
          .then(data => { if (data.ok && data.closed) closeForm(null, false); })
          .catch(() => {});
      }

      form?.addEventListener('submit', async event => {
        event.preventDefault();
        const result = form.querySelector('.ec-form-result');
        const button = form.querySelector('button[type="submit"]');
        const buttonHtml = button.innerHTML;
        const showResult = text => {
          result.textContent = text;
          result.hidden = false;
          result.focus();
        };

        if (!form.dataset.endpoint) {
          showResult('現在、参加申込を受け付けていません。');
          return;
        }

        button.disabled = true;
        button.textContent = '送信しています…';
        result.hidden = true;

        try {
          const response = await fetch(form.dataset.endpoint, {
            method: 'POST',
            headers: {'Content-Type': 'text/plain;charset=utf-8'},
            body: JSON.stringify(Object.fromEntries(new FormData(form)))
          });
          const data = await response.json();
          if (!data.ok && data.closed) {
            closeForm(null, true);
            return;
          }
          if (!data.ok) throw new Error((data.errors || ['送信できませんでした。']).join('\n'));

          const redirect = data.redirect || form.dataset.redirect;
          if (redirect) {
            location.assign(redirect);
            return;
          }

          form.querySelectorAll('label, .ec-party-payment-note, button').forEach(el => {
            el.style.display = 'none';
          });
          showResult(form.dataset.successMessage || '参加申込を受け付けました。');
        } catch (error) {
          const message = error instanceof SyntaxError || error instanceof TypeError
            ? '送信できませんでした。時間をおいてもう一度お試しください。'
            : error.message;
          showResult(message);
          button.disabled = false;
          button.innerHTML = buttonHtml;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
